import React, { useState } from 'react';

const PendingImagesModal = ({ isOpen, onClose, productosPendientes, onImageUpload, onClearAll }) => {
  const [uploadingProducts, setUploadingProducts] = useState(new Set());
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-2xl rounded-lg shadow-xl">
        <div className="p-4 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-bold text-gray-900">Productos Pendientes de Imagen</h2>
            <div className="flex items-center gap-2">
              {productosPendientes.length > 0 && onClearAll && (
                <button
                  onClick={() => {
                    if (window.confirm('¿Limpiar toda la lista de productos pendientes?')) {
                      onClearAll();
                    }
                  }}
                  className="flex items-center gap-1 px-3 py-1.5 text-sm bg-red-100 text-red-600 hover:bg-red-200 rounded-lg transition-colors font-medium"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Limpiar Lista
                </button>
              )}
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 p-1 rounded-full transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="p-4 max-h-[70vh] overflow-y-auto">
          {productosPendientes.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              No hay productos pendientes de imagen
            </div>
          ) : (
            <div className="space-y-4">
              {productosPendientes.map((producto) => (
                <div key={producto.id} className="border border-gray-200 rounded-lg p-4 hover:border-gray-300 transition-colors">
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      <h3 className="font-medium text-gray-900">{producto.nombre}</h3>
                      <p className="text-sm text-gray-500">Categoría: {producto.categoria}</p>
                      <p className="text-xs text-gray-400 mt-1">
                        Ruta de imagen: {producto.imagePath}
                      </p>
                      <p className="text-xs text-gray-400">
                        Fecha: {new Date(producto.fechaCreacion).toLocaleDateString()}
                      </p>
                    </div>
                    <div className="ml-4">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setUploadingProducts(prev => new Set(prev).add(producto.id));
                            try {
                              await onImageUpload(producto.id, file);
                            } finally {
                              setUploadingProducts(prev => {
                                const newSet = new Set(prev);
                                newSet.delete(producto.id);
                                return newSet;
                              });
                            }
                          }
                        }}
                        className="hidden"
                        id={`file-${producto.id}`}
                        disabled={uploadingProducts.has(producto.id)}
                      />
                      <label
                        htmlFor={`file-${producto.id}`}
                        className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200 cursor-pointer font-medium shadow-sm hover:shadow-md ${uploadingProducts.has(producto.id)
                            ? 'bg-gray-400 text-white cursor-not-allowed'
                            : 'bg-blue-500 text-white hover:bg-blue-600 active:bg-blue-700'
                          }`}
                      >
                        {uploadingProducts.has(producto.id) ? (
                          <>
                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                            <span>Subiendo...</span>
                          </>
                        ) : (
                          <>
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <span>Subir Imagen</span>
                          </>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PendingImagesModal; 